export const useDocumentClassroomDataStore = (documentId: string) => {
  return useDocumentClassroomData(documentId)();
};
